import { Link } from 'react-router-dom';

interface IUserWithPicture {
    firstName?: string;
    lastName?: string;
    imgUrl?: string;
    email: string;
    profileUrl?: string;
}

export const UserWithPicture = ({ firstName, lastName, email, imgUrl, profileUrl }: IUserWithPicture) => {
    const fullName = `${firstName} ${lastName}`;
    const displayName = fullName || email;

    return (
        <div className="user-with-picture">
            <img className="user-with-picture__img" src={imgUrl ?? '/svg/person.svg'} alt={displayName} />
            {profileUrl ? (
                <Link to={profileUrl}>
                    <p className="paragraph-3">{displayName}</p>
                </Link>
            ) : (
                <p className="paragraph-3">{displayName}</p>
            )}
        </div>
    );
};
